var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchangedGifts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_974_53158)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_974_53158)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9563 9.70428L6.34991 12.2798L8.41637 23.9992L23.0228 21.4237L20.9563 9.70428Z",
    fill: "#FDBD15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7312 19.7792L19.701 22.0104L23.021 21.4255L22.7312 19.7792Z",
    fill: "#F7E472"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2912 23.6692L14.9583 22.8471L22.3164 17.4282L21.908 15.1151L10.2912 23.6692Z",
    fill: "#F7E472"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93451 15.6014L7.34189 17.9145L17.7145 10.277L13.0474 11.1002L6.93451 15.6014Z",
    fill: "#F7E472"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75653 20.2652L8.16392 22.5793L21.4942 12.7643L21.0858 10.4502L7.75653 20.2652Z",
    fill: "#F7E472"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2868 10.5276L11.0185 11.4565L13.085 23.176L18.3532 22.2471L16.2868 10.5276Z",
    fill: "#0B70D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2862 10.5282L11.0179 11.4571L11.0424 11.5957L16.3107 10.6667L16.2862 10.5282Z",
    fill: "#FAFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8073 9.03806C11.8073 9.03806 15.0968 3.33678 12.5223 0L11.3589 0.506081C11.3589 0.506081 13.5555 3.93 11.8073 9.03806Z",
    fill: "#A1D3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8073 9.03806C11.8073 9.03806 8.92101 4.69857 10.8666 0.0913466L12.5224 0C12.5224 0 10.3395 3.16038 11.8073 9.03806Z",
    fill: "#0B70D0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7034 8.86264C11.7034 8.86264 17.3301 5.44817 16.6844 1.28403L15.4244 1.16748C15.4244 1.16748 15.6932 5.22663 11.7034 8.86264Z",
    fill: "#A1D3FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7034 8.86274C11.7034 8.86274 11.2613 3.67489 15.184 0.568054L16.6844 1.28413C16.6844 1.28413 13.2458 3.00396 11.7034 8.86274Z",
    fill: "#0B70D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4409 9.25532C11.4409 9.25532 4.85974 9.41072 3.1651 5.55211L4.16676 4.77304C4.16676 4.77304 6.11969 8.34186 11.4409 9.25532Z",
    fill: "#A1D3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4409 9.25542C11.4409 9.25542 9.01968 4.64294 4.03867 4.14316L3.1651 5.55221C3.1651 5.55221 6.98486 5.15112 11.4409 9.25542Z",
    fill: "#0B70D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3369 9.08006C11.3369 9.08006 5.643 12.3832 2.29993 9.81608L2.80286 8.65167C2.80286 8.65167 6.23308 10.8398 11.3369 9.08006Z",
    fill: "#A1D3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3369 9.08C11.3369 9.08 6.9901 6.20416 2.38707 8.16024L2.29993 9.81602C2.29993 9.81602 5.45506 7.62686 11.3369 9.08Z",
    fill: "#0B70D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9702 7.30464C14.0856 7.5012 14.1403 7.72752 14.1273 7.95508C14.1144 8.18265 14.0344 8.4013 13.8974 8.58348C13.7604 8.76567 13.5726 8.90326 13.3576 8.97891C13.1426 9.05456 12.91 9.0649 12.6891 9.00862C12.4682 8.95235 12.2689 8.83197 12.1163 8.66265C11.9637 8.49334 11.8646 8.28265 11.8315 8.05713C11.7984 7.83161 11.8328 7.60134 11.9303 7.39532C12.0278 7.18929 12.1841 7.01673 12.3795 6.89936C12.5104 6.82076 12.6555 6.76887 12.8065 6.74671C12.9575 6.72454 13.1115 6.73253 13.2594 6.77022C13.4073 6.80791 13.5463 6.87454 13.6683 6.96627C13.7903 7.058 13.8929 7.17301 13.9702 7.30464Z",
    fill: "#B1D5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6723 9.48105C10.7879 9.67761 10.8428 9.904 10.83 10.1317C10.8172 10.3594 10.7372 10.5782 10.6002 10.7605C10.4632 10.9429 10.2753 11.0806 10.0602 11.1562C9.84507 11.2319 9.61234 11.2422 9.39136 11.1859C9.17038 11.1295 8.97103 11.009 8.81846 10.8395C8.66588 10.6699 8.5669 10.4591 8.534 10.2334C8.50109 10.0077 8.53574 9.77736 8.63356 9.57134C8.73139 9.36533 8.88802 9.19289 9.0837 9.07576C9.21447 8.99749 9.35943 8.94588 9.51024 8.92389C9.66104 8.9019 9.81471 8.90998 9.96238 8.94765C10.11 8.98532 10.2488 9.05185 10.3706 9.1434C10.4925 9.23494 10.595 9.3497 10.6723 9.48105Z",
    fill: "#B1D5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.671 10.4699C13.49 9.76366 13.5815 8.52719 12.8752 7.70815C12.169 6.88911 10.9325 6.79766 10.1135 7.50389C9.29445 8.21011 9.203 9.44658 9.90923 10.2656C10.6155 11.0847 11.8519 11.1761 12.671 10.4699Z",
    fill: "#85BCFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7596 8.17493C12.9203 8.44543 12.9972 8.7575 12.9805 9.07168C12.9638 9.38586 12.8543 9.68803 12.6659 9.93998C12.4774 10.1919 12.2185 10.3823 11.9218 10.4871C11.6252 10.5919 11.3041 10.6064 10.9992 10.5287C10.6944 10.451 10.4194 10.2847 10.209 10.0507C9.99871 9.8167 9.86248 9.5256 9.8176 9.2142C9.77272 8.90279 9.82119 8.58507 9.95688 8.30122C10.0926 8.01736 10.3094 7.78012 10.5799 7.6195C10.9426 7.40414 11.376 7.34168 11.7848 7.44584C12.1936 7.55 12.5442 7.81226 12.7596 8.17493Z",
    fill: "#A1D3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2008 9.83905L6.34863 12.2802L6.97651 15.8427L20.2008 9.83905Z",
    fill: "#9FAFD2"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7648 4.01799L4.06268 12.7128L6.13858 16.2229L20.8407 7.52813L18.7648 4.01799Z",
    fill: "#FDBD15"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3603 6.6024L8.46661 10.0975L10.5464 13.6046L16.4401 10.1095L14.3603 6.6024Z",
    fill: "#0B70D0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_974_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_974_53158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.721,
    height: 24,
    fill: "white",
    transform: "translate(2.29999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangedGifts);
export default __webpack_public_path__ + "static/media/exchangedGifts.e7ce7c39c01ad3c27adb94f4c77a502b.svg";
export { ForwardRef as ReactComponent };